export function showGlobalBanner(ctx, info) {
  const bannerInfo = {
    title: info?.title ?? '',
    body: info?.body ?? '',
    version: info?.version ?? 'error',
    btn: info?.btn ?? '',
    btnEmits: info?.btnEmits ?? 'closeGlobalBanner',
  };
  ctx.$root.$emit('showGlobalBanner', bannerInfo);
}

export function closeGlobalBanner(ctx) {
  ctx.$root.$emit('closeGlobalBanner');
}
